import { render, staticRenderFns } from "./thirdLogin.vue?vue&type=template&id=42469114&scoped=true&"
import script from "./thirdLogin.vue?vue&type=script&lang=js&"
export * from "./thirdLogin.vue?vue&type=script&lang=js&"
import style0 from "./thirdLogin.vue?vue&type=style&index=0&id=42469114&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42469114",
  null
  
)

export default component.exports